import { FIELDS } from '@/pages/Rfp/components/RfpDetails/constants';

const rfpFields = [
  {
    field: FIELDS.STATUS_NAME,
    title: 'Status',
    sortable: true,
    hidden: false,
  },
  {
    field: 'id',
    title: 'RFP No',
    sortable: true,
    hidden: false,
  },
  {
    field: FIELDS.SALES_PERSON_FULL_NAME,
    title: 'Sales Rep',
    sortable: true,
    hidden: false,
  },
  {
    field: FIELDS.PARTS_COUNT,
    title: '# Parts',
    sortable: true,
    hidden: false,
  },
  {
    field: FIELDS.VENDORS_COUNT,
    title: '# Vendors',
    sortable: true,
    hidden: false,
  },
  {
    fields: FIELDS.RECEIVED_COUNT,
    title: '# Rcvd',
    sortable: true,
    hidden: false,
  },
  {
    field: FIELDS.DATE_SENT,
    title: 'Date Sent',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
  },
  {
    field: FIELDS.SENT_BY_USER_FULL_NAME,
    title: 'Sent By',
    sortable: true,
    hidden: false,
  },
  {
    field: FIELDS.DATE_CREATED,
    title: 'Date Created',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
  },
  {
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: 'Created By',
    sortable: true,
    hidden: false,
  },
  {
    field: FIELDS.DATE_MODIFIED,
    title: 'Date Modified',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
  },
  {
    field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: 'Modified By',
    sortable: true,
    hidden: false,
  },
];

export default rfpFields;
